<template>
  <div
    class="h5-keywords-header"
    :class="{ 'hidden': hidden }"
  >
    <Menu
      :search="isSearchPage"
      :text="text"
    />
    <!-- 图片搜索提示 -->
    <div
      v-if="$route.fullPath === '/' && !imageSearchNotice"
      :class="{
        'image-search-floating': true,
        'floating': showImageSearchFloating,
        'collapse': !showImageSearchFloating
      }"
    >
      <img
        src="@/assets/illus/illus-camera.svg"
        alt=""
      >
      Search By Image
      <div class="arrow" />
    </div>
    <H5BestdealerPublicity
      class="h5-keywords-header__publicity"
      v-if="isSearchPage"
    />
    <SearchInput
      v-else
      class="h5-keywords-header__search"
      :text="text"
      show-language
    />
  </div>
</template>

<script setup>
import Menu from './Menu.vue'
import H5BestdealerPublicity from '@/components/BestdealerPublicity/H5BestdealerPublicity.vue'
import SearchInput from './SearchInput.vue'
import storage from '@/utils/storage'

defineProps({
  hidden: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: null
  }
})

const route = useRoute()

const isSearchPage = computed(() => ['search', 'featured'].includes(route.name))

const showImageSearchFloating = ref(true)

const imageSearchNotice = storage.get('imageSearchNotice')

onMounted(async () => {
  setTimeout(() => {
    showImageSearchFloating.value = false
    storage.set('imageSearchNotice', true)
  }, 1100)
})
</script>

<style lang="less" scoped>

.h5-keywords-header {
  padding: 0 12px 12px;
  transition: transform 0.3s ease;
  background-color: #052784;

  &.hidden {
    transform: translateY(-100%);
  }
  .h5-header-top {
    height: 72px;
    .h5-header-top-title {
      color: #FFFFFF;
      font-family: mon-700;
      font-size: 18px;
      line-height: 24px;
      padding-top: 18px;
      text-align: center;
    }
    .h5-header-top-desc {
      color: #f46b6b;
      margin-top: 4px;
      font-family: mon-500;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
    }
  }

  &__publicity {
    margin-top: 8px;
  }

  &__search {
    margin-top: 12px;
  }

  .image-search-floating {
    position: absolute;
    right: 90px;
    bottom: 4px;
    width: 144px;
    height: 32px;
    background-color: #B0C7F5;
    border-radius: 4px;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    color: #232323;
    font-size: 12px;
    font-family: mon-600;
    transform-origin: right center;
    transition: all .3s ease;

    .arrow {
      position: absolute;
      top: 50%;
      right: -10px;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-left: 6px solid #B0C7F5;
    }

    &.floating {
      animation: floating 1s ease-in-out;
    }

    &.collapse {
      transform: scale(0, 0);
      opacity: 0;
    }

    // 上下抖动动画
    @keyframes floating {
      0%, 100% {
        transform: translateY(1px);
      }
      50% {
        transform: translateY(-1px);
      }
    }
  }
}
</style>
